<template>
  <div v-if="showHint">
    <div class="tipBlock">
      <img class="info_icon" :src="info" />
      <span>{{ commissionsText }}</span>
    </div>
  </div>
</template>

<script>
import { apiPaymentGetInfo } from '@/resource';

export default {
  name: 'PtFeeTip',
  props: {
    withdrawalType: Number | String,
    currency: String,
    withdrawalAmount: Number
  },
  data() {
    return {
      showHint: false,
      percentageFee: 0
    };
  },
  watch: {
    withdrawalType(newWithdrawalType) {
      this.getApiPaymentInfo(newWithdrawalType, this.currency, this.withdrawalAmount);
    },
    withdrawalAmount(newWithdrawalAmount) {
      this.getApiPaymentInfo(this.withdrawalType, this.currency, newWithdrawalAmount);
    }
  },
  computed: {
    commissionsText() {
      const commissions = {
        31: 'propTrade.payoutPage.skrillChargeAlert',
        32: 'propTrade.payoutPage.netellerChargeAlert'
      };
      return this.$t(commissions[this.withdrawalType], { percentageFee: this.percentageFee });
    },
    info() {
      return require('@/assets/images/propTrade/trade_processing.png');
    }
  },
  mounted() {
    this.getApiPaymentInfo(this.withdrawalType, this.currency, this.withdrawalAmount);
  },
  methods: {
    getApiPaymentInfo(type, currency, amount) {
      this.showHint = false;
      const getAllParameter = type && currency && amount;
      if (!getAllParameter) return;

      apiPaymentGetInfo({
        withdrawType: type,
        currency: currency,
        withdrawalAmount: amount
      }).then(resp => {
        this.showHint = resp.data.show_hint;
        this.percentageFee = resp.data.percentage_fee;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tipBlock {
  display: flex;
  align-items: center;
  gap: 8px;
  gap: 10px;
  background-color: #fff;
  color: #232020;
  font-size: 14px;
  line-height: 19px;
  font-weight: 400;
  margin: 32px 0;
  @media (max-width: 768px) {
    margin: 20px 0;
  }
  .info_icon {
    width: 14px;
    height: 14px;
  }
}
</style>
